import React from "react";

import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const easilymigrated = require("../../../assets/icons-pack/7.4 Directory Services/ic_01_easilymigrated.svg");
const ActualMicrosoft = require("../../../assets/icons-pack/7.4 Directory Services/ic_02_ActualMicrosoft.svg");
const extend = require("../../../assets/icons-pack/7.4 Directory Services/ic_03_extend.svg");
// Temp icon
const ic_02_operationorientated = require("../../../assets/icons-pack/7.2 Web Application Firewall/ic_02_operationorientated.svg");

const DirectoryService = () => {
    const heading = `DIRECTORY SERVICE`;
    const details = `Use DETASAD Directory Sync to authenticate and integrate your cloud-based work-loads with Microsoft AD.`;

    const overview = [
        `DETASAD Active Directory-as-a-Service for Microsoft Active Directory, also known as DETASAD ADaaS, enables your directory-aware workloads and DETASAD resources to use managed Active Directory in the DETASAD Cloud. DETASAD Microsoft AD is built on actual Microsoft Active Directory and you can easily synchronize or replicate data from your existing Active Directory to the DETASAD cloud.  `,
        `You can use standard Active Directory administration tools and take advantage of built-in Active Directory features, such as Group Policy and single sign-on (SSO). With DETASAD ADaaS, you can easily join DETASAD ECS and DETASAD DBaaS for SQL Server instances to your domain and use DETASAD Enterprise IT applications with Active Directory users and groups. `
    ];

    const advantages = [
        [
            `Easily Migrate Workloads`,
            `DETASAD ADaaS makes it easy to migrate Microsoft Active Directory dependent, on-premises applications and workloads to the DETASAD Cloud.`,
            easilymigrated
        ],
        [
            `Use Actual Microsoft Active Directory`,
            `Take advantage of actual Microsoft Active Directory to manage your users, groups, and devices. Use familiar Active Directory administration tools and Active Directory features`,
            ActualMicrosoft
        ],
        [
            `Easily Extend Existing Domains`,
            `Easily extend your existing Active Directory to the DETASAD Cloud by using DETASAD ADaaS. With DETASAD ADaaS, you can extend your existing Group Policies to your cloud resources.`,
            extend
        ],
        [
            `Simplify Administration`,
            `DETASAD Active Directory-as-a-Service is built on highly available, DETASAD managed infrastructure. DETASAD’s cloud-based AD is simple to administer.`,
            ic_02_operationorientated
        ]
    ];

    const functions = [
        [
            `Highly Available`,
            [
                `The Active Directory in DETASAD Cloud can be deployed with multiple Domain Controllers for high-availability purpose.`
            ]
        ],
        [
            `Disaster Recovery`,
            [
                `The DETASAD Cloud based Active Directory can be extended to the geographically distributed data-centers for disaster recovery solution.`
            ]
        ],
        [
            `Managed Active Directory`,
            [
                `With DETASAD’s Managed Active Directory service, you can leave the management of your AD to us and focus on your core business. We help reduce your IT burden by monitoring and managing your Active Directory service.`
            ]
        ],
        [
            `Extend Complete On-Premises AD Infrastructure`,
            [
                `You can also extend your exiting on-site (on-premises) AD forest to DETASAD Cloud for DR or cloud-authentication purpose.`
            ]
        ],
        [
            `Sync Only Partial On-Premises AD Infrastructure`,
            [
                `If you only want to sync a selective set of AD objects between your on-premises AD forest and your cloud-based AD forest, then you can use DETASAD’s Directory Sync tool.`
            ]
        ],
        [
            `24x7x365 Support Services`,
            [
                `One of the aspects distinguishing DETASAD Directory Service is its customer support. With a 24x7x365 support service, the DETASAD Cloud team provides a distinctive and remarkable customer experience.`
            ]
        ]
    ];
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-security"/>
            <SubNav overview={overview} advantages={advantages} functions={functions} />
            <Footer />
        </div>
    );
};

export default DirectoryService;
